/* eslint-disable @optum-fpc-psx-mobile-apps/no-missing-testid */
import { SuggestionListItem } from '../KeywordSearchDropdown/KeywordSearchDropdown.styled';
import { isLocationActiveSuggetion } from './LocationDropdown.styled';

export const LocationItem = ({
  location,
  onClick,
  index,
  activeSuggestion,
}) => (
  <li
    aria-posinset={index + 1}
    aria-selected={activeSuggestion === index}
    id={activeSuggestion === index ? 'location-search-result-suggestions' : ''}
    key={index}
    role="option"
    style={activeSuggestion === index ? isLocationActiveSuggetion : {}}
  >
    <SuggestionListItem
      className="location-link-span"
      css={{
        '&.abyss-flex-root': {
          fontWeight: '$bold',
        },
      }}
      data-auto-testid={`suggested-location-item${
        activeSuggestion === index ? '-active-suggestion' : ''
      }`}
      data-testid={`suggested-location-item${
        activeSuggestion === index ? '-active-suggestion' : ''
      }`}
      id={`option-${index}`}
      onClick={(event) => {
        event.preventDefault();
        onClick(location);
      }}
    >
      {location?.place_name}
    </SuggestionListItem>
  </li>
);
